import React, { useState } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { BaseUnit } from '../../theming/baseUnitDefinition';
import { useTheme } from '../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { Button } from '../components/buttons/Button';
import { AdditionalStyleSheet } from '../components.utils';

interface DisqusProps {
  resourceID: string;
  canonical: string;
  disqusSource: string;
}

const getButtonStyle = () => {
  return StyleSheet.create({
    style: {
      width: '210px',
      height: '44px',
      [MEDIA_BREAKPOINTS.small]: {
        width: '192px',
        height: '42px',
      },
    },
  }) as AdditionalStyleSheet;
};

const sendDisqusAnalyticsEvent = () => {
  window.mmClientApi = window.mmClientApi || [];
  window.mmClientApi.push('analytics', {
    event_category: 'Article',
    event_action: 'Disqus show/hide button clicked',
  });
};

export const Disqus: React.FunctionComponent<DisqusProps> = props => {
  const { resourceID, canonical, disqusSource } = props;
  const [shouldShowComments, setShouldShowComments] = useState(false);
  const commentsButtonLabel = shouldShowComments ? 'Hide Comments' : 'Show Comments';

  const createStyle = (baseUnit: BaseUnit, showComments: boolean) => {
    return StyleSheet.create({
      disqusWrapper: {
        display: showComments ? 'block' : 'none',
        paddingLeft: `${baseUnit + 80}px`,
        paddingRight: `${baseUnit}px`,
        [MEDIA_BREAKPOINTS.small]: {
          paddingLeft: `${baseUnit}px`,
        },
      },
      buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
      },
    });
  };

  const scriptContent = `
    var disqus_config = function () {
    this.page.url = '${canonical}';  
    this.page.identifier = '${resourceID}';
    };
    (function() { 
    var d = document, s = d.createElement('script');
    s.src = 'https://${disqusSource}/embed.js';
    s.setAttribute('data-timestamp', +new Date());
    (d.head || d.body).appendChild(s);
    })();
  `;

  React.useEffect(() => {
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = scriptContent;
    document.head.appendChild(scriptElement);
  }, [scriptContent]);

  const { baseUnit } = useTheme();
  const { disqusWrapper, buttonWrapper } = createStyle(baseUnit, shouldShowComments);

  const onCommentsButtonClick = () => {
    setShouldShowComments(!shouldShowComments);
    sendDisqusAnalyticsEvent();
  };

  return (
    <>
      <div id="disqus_thread" className={css(disqusWrapper)} />
      <div className={css(buttonWrapper)}>
        <Button label={commentsButtonLabel} onClick={onCommentsButtonClick} additionalStyle={getButtonStyle()} />
      </div>
    </>
  );
};
